module.exports = __webpack_public_path__ + "img/vip_title2.f753b617.png";